import { Navigate } from '~/utils/navigation';
import { useSelector } from 'react-redux';
import useContextualPathTransformer from '~/hooks/use-contextual-path-transformer.js';
import { ROUTE_GLOBAL } from '~/components/router/constants.js';
import useCasinoRoutes from './use-casino-routes';
import { isSmallerSelector } from '~/components/layout/mediaquery';

const GlobalExploreRedirect = () => {
	const smaller = useSelector(isSmallerSelector);
	const transformPath = useContextualPathTransformer();
	const { ROUTE_CASINO_EXPLORE } = useCasinoRoutes();

	return (
		<Navigate
			to={
				smaller
					? transformPath(ROUTE_GLOBAL, {
							location: {
								pathname: ROUTE_CASINO_EXPLORE
							}
						})
					: ROUTE_CASINO_EXPLORE
			}
		/>
	);
};

export default GlobalExploreRedirect;
